"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./helpPopup.scss");
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const BaseButton_1 = __importDefault(require("../../../elementKit/baseButton/BaseButton"));
const helpPopupTranslations_json_1 = __importDefault(require("./helpPopupTranslations/helpPopupTranslations.json"));
const pending_icon_svg_1 = __importDefault(require("../../../assets/images/icons/pending-icon.svg"));
const close_icon_gray_svg_1 = __importDefault(require("../../../assets/images/icons/close-icon-gray.svg"));
const react_1 = __importDefault(require("react"));
const master_1 = require("../../../constants/master");
const constants_1 = require("../../../constants");
const ElementBaseConfig_1 = require("../../../config/ElementBaseConfig");
const HelpPopup = (props) => {
    props.addTranslation(helpPopupTranslations_json_1.default);
    const config = (0, master_1.getMasterConfig)();
    return (react_1.default.createElement(Modal_1.default, { size: "sm", show: props.show, onHide: props.onClose, animation: false, dialogClassName: "help-popup-modal" },
        react_1.default.createElement(Modal_1.default.Body, { className: "flex-column ai-c" },
            react_1.default.createElement("img", { src: close_icon_gray_svg_1.default, alt: "Close", height: 12, width: 12, className: "close-icon", onClick: () => {
                    props.onClose();
                } }),
            react_1.default.createElement("img", { src: pending_icon_svg_1.default, alt: "Warning", height: 20, width: 20 }),
            react_1.default.createElement("span", { className: "help-modal-title" }, props.translate("howCanWeHelp").toString()),
            react_1.default.createElement("span", { className: "help-modal-desc" }, props.translate("selectAnOption").toString()),
            props.disabledNameChange ? null : (react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", height: props.isMobile ? 55 : 40, loading: false, width: 282, className: "help-modal-button", styles: {
                    marginBottom: "11px",
                }, onClickAction: () => {
                    props.openNameChangePopup();
                    props.onClose();
                } },
                react_1.default.createElement("span", { className: "button-label" }, props.translate("wantChangeName").toString()))),
            config.subDomain !== constants_1.Subdomains.bitdefender && (react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", width: 282, height: props.isMobile ? 55 : 40, loading: false, className: "help-modal-button", styles: {
                    marginBottom: "11px",
                }, onClickAction: () => {
                    window.open((0, ElementBaseConfig_1.getElementkitConfig)()
                        .helpPopupNeedHelpWithMyCredentialRedirectLink, "_blank");
                    props.onClose();
                } },
                react_1.default.createElement("span", { className: "button-label" }, props.translate("needHelpWithMyCredential").toString()))),
            config.subDomain !== constants_1.Subdomains.bitdefender && (react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", className: "help-modal-button", width: 282, height: props.isMobile ? 55 : 40, loading: false, onClickAction: () => {
                    window.open((0, ElementBaseConfig_1.getElementkitConfig)().helpPopupQuestionAboutSharingRedirectLink, "_blank");
                    props.onClose();
                } },
                react_1.default.createElement("span", { className: "button-label" }, props.translate("questionAboutSharing").toString()))))));
};
exports.default = HelpPopup;
